
import { default as OperationStatus } from './Operation.Status';
export { OperationStatus };

export const PAYOUT_STATUS_NAME = [
  { id: -1, value: 'Все' },
  { id: 1, value: 'В обработке' },
  { id: 3, value: 'Отклонена' },
  { id: 4, value: 'Проведена' },
  { id: 5, value: 'Ожидает авторизации' },
  { id: 9, value: 'Ссылка создана' },
];

export const PAYOUT_STATUS = {
  1: 'В обработке',
  2: 'В обработке',
  3: 'Проведена',
  4: 'Отклонена',
  5: 'Ожидает авторизации',
  6: 'В обработке',
  7: 'В обработке',
  9: 'Ссылка создана',
  999: 'В обработке',
};


export const OPERATION_STATUS_NAME = [
  { id: -1, value: 'Все' },
  { id: 1, value: 'В обработке' },
  { id: 2, value: 'Отменен' },
  { id: 3, value: 'Отклонен' },
  { id: 4, value: 'Проведен' },
  { id: 5, value: 'Возвращен' },
  { id: 6, value: 'Частично возвращен' },
  { id: 7, value: 'Новый' },
  { id: 10, value: 'Средства захолдированы' }
];

export const OPERATION_STATUS = {
  1: OPERATION_STATUS_NAME[7]['value'],
  2: OPERATION_STATUS_NAME[1]['value'],
  101: OPERATION_STATUS_NAME[1]['value'],
  8: OPERATION_STATUS_NAME[2]['value'],
  4: OPERATION_STATUS_NAME[3]['value'],
  103: OPERATION_STATUS_NAME[3]['value'],
  3: OPERATION_STATUS_NAME[4]['value'],
  102: OPERATION_STATUS_NAME[4]['value'],
  7: OPERATION_STATUS_NAME[5]['value'],
  6: OPERATION_STATUS_NAME[6]['value'],
  104: PAYOUT_STATUS_NAME[4]['value'],
  105: PAYOUT_STATUS_NAME[1]['value'],
  10: OPERATION_STATUS_NAME[8]['value'],
  9: OPERATION_STATUS_NAME[1]['value'],
};


export const CURRENCY_SYMBOLS = {
  'RU': 'RUB',
  'RUB': 'RUB',
  'EUR': 'EUR',
  'USD': 'USD',
  'UAH': 'UAH',
  'KZT': 'KZT',
  'CNY': 'CNY',
  'VND': 'VND'
};

export const OPERATION_TYPES = [
  { id: 'PAY', value: 'Платеж' },
  { id: 'REFUND', value: 'Возврат' },
  { id: 'PAYOUT', value: 'Выплата' },
  { id: 'REVERSE', value: 'Возврат в тот же день' },
  { id: 'LOST_PAY', value: 'Неопознанные платежи, поступление' },
  { id: 'LOST_PAYOUT', value: 'Неопознанные платежи, списание' },
  { id: 'MANUAL_PAY', value: 'Ручное начисление' },
  { id: 'MANUAL_PAYOUT', value: 'Ручное списание' },
  { id: 'TRANSFER_PAY', value: 'Платеж (перевод)' },
  { id: 'TRANSFER_PAYOUT', value: 'Выплата (перевод)' },
  { id: 'EXCHANGE_PAY', value: 'Платеж (конвертация)' },
  { id: 'EXCHANGE_PAYOUT', value: 'Выплата (конвертация)' },
  { id: 'TRANSFER_EXCHANGE_PAY', value: 'Платеж (перевод-обменник)' },
  { id: 'TRANSFER_EXCHANGE_PAYOUT', value: 'Выплата (перевод-обменник)' },
  { id: 'TRANSFER_ADVERTISING_PAY', value: 'Платеж (перевод-реклама)' },
  { id: 'TRANSFER_ADVERTISING_PAYOUT', value: 'Выплата (перевод-реклама)' },
  { id: 'HOLD_PAY', value: 'Захолдированные платежи, поступление' },
  { id: 'HOLD_PAYOUT', value: 'Захолдированные платежи, списание' },
  { id: 'INCOME_PAY', value: 'Доходность, поступление' },
  { id: 'INCOME_PAYOUT', value: 'Доходность, списание' },
  { id: 'VALIDATION_PAY', value: 'Валидация, поступление' },
  { id: 'VALIDATION_PAYOUT', value: 'Валидация, списание' },
  { id: 'CARD_VALIDATION_PAYOUT', value: 'Валидация карт' },
  { id: 'COD_PAY', value: 'Наложенные платежи, поступление' },
  { id: 'REWARD_COD_PAYOUT', value: 'Вознаграждение COD' },
  { id: 'ACQUIRING_PAY', value: 'Оплата эквайринг, поступление' },
];

export const FILTERED_OPERATION_TYPES = [
  { id: 'PAY', value: 'Платеж' },
  { id: 'REFUND', value: 'Возврат' },
  { id: 'PAYOUT', value: 'Выплата' },
  { id: 'MANUAL_PAY', value: 'Ручное начисление' },
  { id: 'MANUAL_PAYOUT', value: 'Ручное списание' },
  { id: 'TRANSFER_PAY', value: 'Платеж (перевод)' },
  { id: 'TRANSFER_PAYOUT', value: 'Выплата (перевод)' },
  { id: 'EXCHANGE_PAY', value: 'Платеж (конвертация)' },
  { id: 'EXCHANGE_PAYOUT', value: 'Выплата (конвертация)' },
  { id: 'TRANSFER_EXCHANGE_PAY', value: 'Платеж (перевод-обменник)' },
  { id: 'TRANSFER_EXCHANGE_PAYOUT', value: 'Выплата (перевод-обменник)' },
  { id: 'TRANSFER_ADVERTISING_PAY', value: 'Платеж (перевод-реклама)' },
  { id: 'TRANSFER_ADVERTISING_PAYOUT', value: 'Выплата (перевод-реклама)' },
  { id: 'VALIDATION_PAY', value: 'Валидация, поступление' },
  { id: 'VALIDATION_PAYOUT', value: 'Валидация, списание' },
  { id: 'CARD_VALIDATION_PAYOUT', value: 'Валидация карт' },
  { id: 'COD_PAY', value: 'Наложенные платежи, поступление' },
  { id: 'REWARD_COD_PAYOUT', value: 'Вознаграждение COD' },
  { id: 'ACQUIRING_PAY', value: 'Оплата эквайринг, поступление' },
];

export const currencies = [
  { id: 'RUB', value: 'Рубль (₽)' },
  { id: 'EUR', value: 'Евро (€)' },
  { id: 'USD', value: 'Доллар США ($)' },
  { id: 'UAH', value: 'Гривна (₴)' },
  { id: 'KZT', value: 'Тенге (₸)' },
  { id: 'CNY', value: 'Юань (¥)' },
  { id: 'VND', value: 'Донг (₫)' },
];

export const CURRENCY_NAMES = [
  { id: 'RUB', value: 'RUB' },
  { id: 'USD', value: 'USD' },
  { id: 'EUR', value: 'EUR' },
  { id: 'UAH', value: 'UAH' },
  { id: 'KZT', value: 'KZT' },
  { id: 'CNY', value: 'CNY' },
  { id: 'VND', value: 'VND' },
];

export const ROLES = [
  { caption: 'Администраторы', value: 'merchant-admin' },
  { caption: 'Бухгалтерия', value: 'merchant-accountant' },
  { caption: 'Поддержка', value: 'merchant-support' },
  { caption: 'Поддержка+', value: 'merchant-support-plus' },
  { caption: 'Менеджеры', value: 'merchant-manager' },
  { caption: 'Разработчики', value: 'merchant-developer' },
  { caption: 'Логист', value: 'merchant-logist' },
];

export const payoutMethods = [
  {
    payment: { id: 2, name: 'WMR', title: 'WMP' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
  {
    payment: { id: 23, name: 'WMZ', title: 'WMZ' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
  {
    payment: { id: 5, name: 'YandexMoney', title: 'Яндекс.Деньги' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
  {
    payment: { id: 1, name: 'BankCard', title: 'Банковские карты' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
  {
    payment: { id: 6, name: 'Mobile', title: 'Мобильные операторы' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
  {
    payment: { id: 13, name: 'Qiwi', title: 'QIWI Кошелек' },
    currency: { id: 'RUB', name: 'RUB', title: 'Рубль' },
    limitsDescription: '',
    payoutDescription: '',
  },
];


export const TRANSACTION_STATUS_NAME = [
  { id: 1, value: 'В обработке' },
  { id: 2, value: 'Отменен' },
  { id: 3, value: 'Отклонен' },
  { id: 4, value: 'Проведен' },
  { id: 5, value: 'Возвращен' },
  { id: 6, value: 'Частично возвращен' },
  { id: 10, value: 'Средства захолдированы' }
];


export const TRANSACTION_STATUS = {
  '-1': TRANSACTION_STATUS_NAME[0]['value'],
  301: TRANSACTION_STATUS_NAME[0]['value'],
  302: TRANSACTION_STATUS_NAME[2]['value'],
  303: TRANSACTION_STATUS_NAME[0]['value'],
  304: TRANSACTION_STATUS_NAME[3]['value'],
  310: TRANSACTION_STATUS_NAME[6]['value'],
  311: TRANSACTION_STATUS_NAME[1]['value'],
  312: TRANSACTION_STATUS_NAME[0]['value'],
};

export const OPERATION_TYPE = {
  'PAY': 'Платеж',
  'PAYOUT': 'Выплата',
  'REFUND': 'Возврат',
};

export const PAYMENT_METHOD = {
  1: 'Банковская карта',
  2: 'WebMoney',
  3: 'Наложенный платеж',
  5: 'YooMoney',
  13: 'QIWI Wallet',
  18: 'Банковская карта',
  21: 'ApplePay',
  22: 'GooglePay',
  23: 'WMZ',
  24: 'Перевод',
  25: 'Конвертация',
  26: 'Система быстрых платежей',
  30: 'Перевод-обменник',
  31: 'Перевод-реклама'
};

export const INVOICE_PAYED_STATUS_CODE = 3;
export const INVOICE_PARTLY_REFUNDED_STATUS_CODE = 6;
export const INVOICE_REFUNDED_STATUS_CODE = 7;
export const INVOICE_CANCELED_STATUS_CODE = 8;
